const company = {
  company: {
    pageHeader: 'Profil firmy',
    branchProfile: 'Profil oddziału',
    addBranchOffice: 'Dodaj oddział',
    companyDetails: 'Dane firmy',
    branchDetails: 'Szczegóły oddziału',
    companyName: 'Nazwa firmy',
    branchName: 'Nazwa oddziału',
    websiteURL: 'Adres URL witryny',
    url: 'Adres URL',
    yearFounded: 'Rok założenia',
    companyLogo: 'Logo firmy',
    imageFormatDescription: 'Musi to być plik JPEG, GIF lub PNG nie większy niż 4 MB.',
    imageShapeDescription:
      'Aby uzyskać najlepszy efekt, zalecamy kwadratowy obraz z przezroczystym tłem o szerokości co najmniej 400 pikseli i wysokości 400 pikseli.',
    noFile: 'Nie wybrano żadnego pliku',
    companyDescription: 'Opis firmy',
    myTestEdit: 'Edycja mojego testu',
    customerWelcomeEmail: 'Powitalna wiadomość e-mail dla klienta',
    testEditMessage: 'wiadomości e-mail dotycząca edycji testu',
    companyDescriptionTooltip:
      'Wpisany tutaj tekst będzie widoczny w widokach publicznych systemów zainstalowanych przez Twoją firmę. Możesz dołączyć dane kontaktowe w celu generowania potencjalnych klientów wśród osób odwiedzających te strony.',
    editCompanyInformation: 'Edytuj dane firmowe',
    welcomeEmailDescription:
      'Wpisany tutaj tekst będzie widoczny w powitalnej wiadomości e-mail wysyłanej do nowych klientów po utworzeniu konta Enlighten. Do tej wiadomości możesz dołączyć logo swojej firmy.',
    editWelcomeMessage: 'Edytuj powitalną wiadomość e-mail dla klienta',
    checkboxDisplayLogo: 'Wyświetlaj logo firmy w powitalnej wiadomości e-mail dla klienta',
    previewEmail: 'Podgląd powitalnej wiadomości e-mail dla klienta',
    contactDetails: 'Dane kontaktowe',
    streetAddress: 'Ulica i numer',
    streetAddress2: 'Ulica i numer 2',
    city: 'Miejscowość',
    zipCode: 'Kod pocztowy',
    customerSupport: 'Dane kontaktowe obsługi klienta',
    country: 'Kraj',
    state: 'Województwo/powiat',
    contactOwnerDescription: 'dla właściciela systemu/właściciela domu',
    businessContacts: 'Biznesowe dane kontaktowe',
    sameCheckbox: 'Takie same jak do obsługi klienta',
    contactEnphaseDescription: 'dotyczące Enphase',
    installationDetails: 'Szczegóły instalacji',
    servicesOffered: 'Oferowane usługi',
    installationType: 'Typ instalacji',
    salesEmployeeNumber: 'Liczba pracowników w dziale sprzedaży',
    workmanshipWarranty: 'Oferowana gwarancja na robociznę (lata)',
    installationEmployeeNumber: 'Liczba pracowników wykonujących instalacje',
    typicalInstallationsYear: 'Typowe instalacje (rocznie)',
    typicalInstallationsMonth: 'Typowe instalacje (kW/miesiąc)',
    enphaseShare: 'Udział Enphase w instalacjach',
    sgipDeveloper: 'Czy jesteś deweloperem SGIP?',
    sgipDeveloperTooltip: 'Wybierz, jeśli jesteś zarejestrowany(-a) jako deweloper SGIP w witrynie selfgenca.com',
    fein_ein: 'FEIN/EIN',
    sgipDeveloperKey: 'Klucz dewelopera SGIP',
    businessLicenses: 'Licencje biznesowe',
    addNewLicense: 'DODAJ NOWĄ LICENCJĘ',
    licenseType: 'Typ licencji',
    licenseNo: 'Nr licencji',
    none: 'Brak',
    licensingBoard: 'Komisja ds. zezwoleń',
    licensingAuthority: 'Organ wydający zezwolenia',
    expiryDate: 'Data wygaśnięcia',
    profileLinks: 'Linki do profilów',
    yelpAccountLink: 'Link do konta Yelp',
    rating: 'Ocena',
    reviews: 'Opinie',
    yelpAccountLinkTooltip:
      'Aby uzyskać to łącze, przejdź do swojego profilu Yelp i skopiuj link/adres URL z paska adresu przeglądarki internetowej',
    yelpAccountLinkError:
      'Nie udało nam się uzyskać Twojego profilu Yelp. Sprawdź wprowadzony przez Ciebie link profilu',
    googlePlaceId: 'Identyfikator miejsca Google',
    clickHere: 'Kliknij tutaj',
    findPlaceId: ', aby znaleźć swój identyfikator miejsca Google',
    placeIdError:
      'Nie mogliśmy znaleźć prawidłowej lokalizacji dotyczącej tego identyfikatora. Sprawdź wprowadzony przez Ciebie identyfikator.',
    solarProfileLink: 'Link do profilu SolarReviews',
    solarProfileLinkTooltip:
      'Aby uzyskać ten link, przejdź do swojego profilu SolarReviews.com i skopiuj link/adres URL z paska adresu przeglądarki internetowej',
    bbbProfileLink: 'Link do profilu BBB',
    bbbProfileLinkTooltip:
      'Aby uzyskać ten link, przejdź do swojego profilu BBB.org i skopiuj link/adres URL z paska adresu przeglądarki internetowej',
    solarQuotesProfileLink: 'Link do profilu Solarquotes',
    solarQuotesTooltip:
      'Aby uzyskać ten link, przejdź do swojego profilu solarquotes.com i skopiuj link/adres URL z paska adresu przeglądarki internetowej',
    productReviewProfileLink: 'Link do profilu ProductReview',
    productReviewTooltip:
      'Aby uzyskać ten link, przejdź do swojego profilu productreview.com.au i skopiuj link/adres URL z paska adresu przeglądarki internetowej',
    trustPilotLink: 'Link do profilu Trustpilot',
    trustPilotTooltip:
      'Aby uzyskać ten link, przejdź do swojego profilu trustpilot.com i skopiuj link/adres URL z paska adresu przeglądarki internetowej',
    facebookLink: 'Link do profilu Facebook',
    facebookTooltip:
      'Aby uzyskać ten link, przejdź do swojego profilu facebook.com i skopiuj link/adres URL z paska adresu przeglądarki internetowej',
    justDialLink: 'Link do profilu Just Dial',
    justDialTooltip:
      'Aby uzyskać ten link, przejdź do swojego profilu justdial.com i skopiuj link/adres URL z paska adresu przeglądarki internetowej',
    listOfReferenceSystems: 'Lista systemów referencyjnych',
    referenceListDescription:
      'Twoja lista referencyjna jest aktualizowana automatycznie, aby przedstawiać systemy, które właściciele zdecydowali się udostępnić. Wymienione systemy mogą na przestrzeni całego okresu użytkowania wyprodukować co najmniej 100 kWh energii',
    requestSystemAccess: 'Wyślij prośbę o przyznanie dostępu do systemu',
    maintainer: 'Serwisant',
    view_only: 'Tylko podgląd',
    linkRequestAccess: 'Wyślij ten link właścicielom systemów, aby uzyskać dostęp do ich systemu w Enlighten',
    fieldRequired: 'To pole jest wymagane.',
    validEmail: 'Wprowadź prawidłowy adres e-mail.',
    validPhone: 'Wprowadź prawidłowy numer telefonu.',
    supportContact: 'Uzupełnij przynajmniej jedno z powyższych pól (telefon/e-mail).',
    serviceRequired: 'Wymagany jest co najmniej jeden typ usługi',
    installationRequired: 'Wymagany jest co najmniej jeden typ instalacji',
    minLength: 'Minimalna dozwolona długość wynosi 2',
    maxLength: 'Maksymalna dozwolona długość wynosi 15',
    dateWarning: 'Ostrzeżenie: ta licencja zostanie uznana za wygasłą, ponieważ data jej wygaśnięcia już minęła',
    correctValue: 'Wprowadź wartość mniejszą lub równą',
    feinLength: 'Wprowadź 9-cyfrowy numer',
    less_than_25: 'Mniej niż 25%',
    between_25_50: '25–50%',
    between_50_90: '50–90%',
    greater_than_90: 'Więcej niż 90%',
    roofingFr: 'QualiPV Bâtiment',
    solarFr: 'QualiPV Electricité (inférieur ou égale à 36kVA)',
    storageFr: 'QualiPV Electricité (supérieur à 36kVA ou inférieur ou égale à 250kVA)',
    electricalFr: 'QualiPV Electricité (supérieur à 250kVA)',
    othersFr: 'Autres',
    roofing: 'Pokrycie dachu',
    solar: 'Energia słoneczna',
    storage: 'Magazynowanie',
    electrical: 'Elektryczne',
    ev_charger: 'Ładowarka EV',
    others: 'Inne',
    commercial: 'Użytek komercyjny',
    residential: 'Użytek domowy',
    new_homes: 'Nowe domy',
    installer: 'Instalator',
    roles_distributor: 'Dystrybutor',
    roles_support: 'Firma wspierająca',
    cec: 'CEC',
    electrical_contract: 'Umowa dot. elektryczności',
    abn_number: 'Numer ABN',
    acn_number: 'Numer ACN',
    installateurverzeichniss_elektro_eintrag: 'Installateurverzeichniss Elektro Eintrag',
    sgze: 'SGZE',
    zonnekeur: 'Zonnekeur',
    holland_solar: 'Holland Solar',
    techniek_nederland: 'Techniek Nederland',
    installq: 'InstallQ',
    fedelec: 'Fedelec',
    pv_vlaanderen: 'PV-Vlaanderen',
    selectCountry: 'Wybierz kraj',
    yellowPageLink: 'Żółty link do strony',
    yellowPageTooltip:
      'Aby uzyskać ten link, przejdź do swojego profilu https//www.pagesjaunes.fr/ i skopiuj link/adres URL z paska adresu przeglądarki internetowej.',
    enrQualityDirectoryLink: 'Annuary Qualit’Enr',
    enrQualityDirectoryTooltip:
      'Aby uzyskać ten link, przejdź do swojego profilu https//www.qualit-enr.org/annuaire/ i skopiuj link/adres URL z paska adresu przeglądarki internetowej.',
    validChamberNumber: 'Nieprawidłowe dane wejściowe! Minimum 8 znaków wymaganych dla numeru Izby Handlowej',
    chamberofcommerce : 'Numer Izby Handlowej',
  }
};

export default company;
